import { render, staticRenderFns } from "./fandom-autocomplete.vue?vue&type=template&id=714afa0c&scoped=true&"
import script from "./fandom-autocomplete.vue?vue&type=script&lang=js&"
export * from "./fandom-autocomplete.vue?vue&type=script&lang=js&"
import style0 from "./fandom-autocomplete.vue?vue&type=style&index=0&id=714afa0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "714afa0c",
  null
  
)

export default component.exports